import request from '@/utils/requestExport'
import api from '../api'

export class FileExport {
    //手续费明细导出
    feeDetailExport(data) {
        return request({
            url: api.fileDownload.feeDetailExport,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    //账户详细导出
    merAccount(data) {
        return request({
            url: api.fileDownload.merAccount,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    //手续费月报
    merMonthExport(data) {
        return request({
            url: api.fileDownload.feeMonthExport,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    //下载缺失订单信息
    withoutOrders(data) {
        return request({
            url: api.fileDownload.withoutOrders,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    // 下载收结汇交易
    receiptTrans(data) {
        return request({
            url: api.fileDownload.receiptTrans,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    //收结汇订单详情导出
    merDistributes(data) {
        return request({
            url: api.fileDownload.merDistributes,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    //下发批次导出
    distributeBatches(data) {
        return request({
            url: api.fileDownload.merDistributesBatch,
            method: 'post',
            data,
            'responseType': "blob",
        })
    }
    // //下发详情导出
    // distributeDetail(data) {
    //     return request({
    //         url: api.fileDownload.merDistributes,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //充值导出
    // depositExport(data) {
    //     return request({
    //         url: api.fileDownload.depositExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // overseaExport(data) {
    //     return request({
    //         url: api.fileDownload.overseaExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //提现交易导出
    // withdrawExport(data) {
    //     return request({
    //         url: api.fileDownload.withdrawExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //网关支付
    // gatewayExport(data) {
    //     return request({
    //         url: api.fileDownload.gatewayExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //鉴权
    // authExport(data) {
    //     return request({
    //         url: api.fileDownload.authExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //代付
    // paidMerExport(data) {
    //     return request({
    //         url: api.fileDownload.paidMerExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //扫码支付
    // scanPayMerExport(data) {
    //     return request({
    //         url: api.fileDownload.scanPayMerExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //退款
    // refundMerExport(data) {
    //     return request({
    //         url: api.fileDownload.refundMerExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //银联支付
    // unionMerExport(data) {
    //     return request({
    //         url: api.fileDownload.unionMerExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //订单推送导出
    // discountExport(data) {
    //     return request({
    //         url: api.fileDownload.discountExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    // //前端海关推单
    // commitExport(data) {
    //     return request({
    //         url: api.fileDownload.commitExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }

    // //购付汇交易
    // purchaseTrans(data) {
    //     return request({
    //         url: api.fileDownload.purchaseExport,
    //         method: 'post',
    //         data,
    //         'responseType': "blob",
    //     })
    // }
    exportMultiDenominationList(data) {
      return request({
        url: api.fileDownload.exportMultiDenominationList,
        method: 'post',
        data,
        'responseType': "blob",
      })
    }
}
